module.exports = __webpack_public_path__ + "static/img/8.65097f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/eng/8.png
// module id = TR09
// module chunks = 0